import { render } from "./ssoRedirectContent.vue?vue&type=template&id=2b90d584"
import script from "./ssoRedirectContent.vue?vue&type=script&lang=js"
export * from "./ssoRedirectContent.vue?vue&type=script&lang=js"

import "./ssoRedirectContent.vue?vue&type=style&index=0&id=2b90d584&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__